/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type GetQuickLinkQueryVariables = Exact<{
  context: Types.ZalamoObject;
  contextId: string;
}>;

export type GetQuickLinkQuery = {
  quickLink: {
    link: Array<string | null> | null;
    quickLinkId: string | null;
    label: Array<{
      language: string | null;
      text: string | null;
    } | null> | null;
  } | null;
};

export const GetQuickLinkDocument = gql`
  query GetQuickLink($context: ZalamoObject!, $contextId: ID!) {
    quickLink(contextId: $contextId, context: $context) {
      label {
        language
        text
      }
      link
      quickLinkId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetQuickLinkGQL extends Apollo.Query<
  GetQuickLinkQuery,
  GetQuickLinkQueryVariables
> {
  document = GetQuickLinkDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
